import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-207" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight tracking-tight text-foreground sm:text-4xl" data-id="element-208" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-209" data-mp="n09ajoyil75h">
        <span className="h-1 w-10 rounded-full bg-accent" data-id="element-210" data-mp="i76d35qm9dk0" />
        <span className="h-1 w-3 rounded-full bg-primary shadow-glow" data-id="element-211" data-mp="d8lns1cwkeac" />
      </span>
    </div>;
}